"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var OptimiseRow_1 = __importDefault(require("components/Optimise/OptimiseRow"));
var StyledCollapse_1 = __importDefault(require("shared/components/Collapse/StyledCollapse"));
var TableRow_1 = __importDefault(require("shared/components/Table/TableRow"));
var OptimiseFeedback_1 = __importDefault(require("./OptimiseFeedback"));
var OptimiseDetails_1 = __importDefault(require("./OptimiseTypes/OptimiseDetails"));
var RecommendationContext_1 = require("./RecommendationContext");
var PREFIX = 'OptimiseAction';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    isOpen: "".concat(PREFIX, "-isOpen"),
    stickyWrapper: "".concat(PREFIX, "-stickyWrapper"),
    topStickyBottom: "".concat(PREFIX, "-topStickyBottom"),
    topSticky: "".concat(PREFIX, "-topSticky"),
};
var StyledRecommendationContextProvider = (0, material_1.styled)(RecommendationContext_1.RecommendationContext.Provider)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            width: 'calc(100% - 28px)',
            marginLeft: theme.spacing(1),
            zIndex: 'auto',
        },
        _b[".".concat(classes.isOpen)] = {
            width: 'calc(100% - 10px)',
            paddingTop: theme.spacing(4),
        },
        _b[".".concat(classes.stickyWrapper)] = {
            width: '100%',
            backgroundColor: theme.palette.common.white,
            zIndex: 'auto',
            position: 'sticky',
            top: 151,
        },
        _b[".".concat(classes.topStickyBottom)] = {
            top: 151,
        },
        _b[".".concat(classes.topSticky)] = {
            width: 'calc(100% - 10px)',
        },
        _b);
});
var OptimiseAction = function (_a) {
    var isOpen = _a.isOpen, onClickRow = _a.onClickRow, recommendation = _a.recommendation, showServiceStat = _a.showServiceStat, isAdmin = _a.isAdmin;
    var _b = __read(react_1.default.useState(false), 2), showFeedbackForm = _b[0], setShowFeedbackForm = _b[1];
    if (recommendation.isSoftDelete && !isAdmin) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(StyledRecommendationContextProvider, __assign({ value: { recommendation: recommendation } }, { children: [(0, jsx_runtime_1.jsxs)(TableRow_1.default, __assign({ id: isOpen ? 'rowHeader' : 'accordionRow' }, { children: [isOpen
                        ? ((0, jsx_runtime_1.jsx)("td", __assign({ colSpan: 27 }, { children: (0, jsx_runtime_1.jsx)(StyledCollapse_1.default, __assign({ in: isOpen, timeout: "auto", unmountOnExit: true, sx: { m: '0 -32px', p: 4 } }, { children: (0, jsx_runtime_1.jsx)(OptimiseDetails_1.default, { recommendation: recommendation, onClickClose: function () { return onClickRow(null); } }) })) })))
                        : ((0, jsx_runtime_1.jsx)(OptimiseRow_1.default, { recommendation: recommendation, showServiceStat: showServiceStat, openView: function () { return onClickRow(recommendation); }, isAdmin: isAdmin })), !isOpen && showFeedbackForm && (0, jsx_runtime_1.jsx)(OptimiseFeedback_1.default, { onCancel: function () { return setShowFeedbackForm(false); } })] })), (0, jsx_runtime_1.jsx)(TableRow_1.default, { sx: { height: 32 } })] })));
};
exports.default = OptimiseAction;
